/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ErrorHeader: {
        id: 'qnb.spm.errorPage.ErrorHeader',
        defaultMessage: 'Thank you for your interest in Saga {vehicleType} Insurance.'
    },
    DeclineErrorMessage: {
        id: 'qnb.spm.errorPage.DeclineErrorMessage',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to offer you a quotation.'
    },
    ReferralMessage1: {
        id: 'qnb.spm.errorPage.ReferralMessage1',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to complete your online quotation'
    },
    ReferralMessage2: {
        id: 'qnb.spm.errorPage.ReferralMessage2',
        defaultMessage: 'You can give us a call and one of our customer service advisers will be happy to help'
    },
    LinesOpen: {
        id: 'qnb.spm.errorPage.LinesOpen',
        defaultMessage: 'Our lines are open 8.30am to 8pm weekdays, 9am to 5pm Saturday and 9am to 5pm Sunday.'
    },
    ExistingCustomerHeader: {
        id: 'qnb.spm.errorPage.ExistingCustomerHeader',
        defaultMessage: 'Are you an existing customer?'
    },
    ExistingCustomerAnswer1: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer1',
        defaultMessage: 'Yes, I\'m thinking about renewing my policy'
    },
    ExistingCustomerAnswer1Content0: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer1Content0',
        defaultMessage: "We send renewal documents out at least 21 days before your renewal is due. If you'd like to talk to us about your renewal, we'll be happy to help - just "
    },
    ExistingCustomerAnswer1Content1: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer1Content1',
        defaultMessage: 'call us free on {phoneNumber}.'
    },
    ExistingCustomerAnswer1Content2: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer1Content2',
        defaultMessage: "<strong>Important: </strong>if you don't want to continue with your Saga policy, please let us know before your renewal date."
    },
    ExistingCustomerAnswer2: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer2',
        defaultMessage: 'Yes, I am thinking about making some changes to my policy'
    },
    ExistingCustomerAnswer2Content0: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer2Content0',
        defaultMessage: 'To find out more about making changes to your policy, please visit the policy details section of our website '
    },
    ExistingCustomerAnswer2Content1: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer2Content1',
        defaultMessage: 'Alternatively, if you would like to speak to one of our customer service advisers '
    },
    ExistingCustomerAnswer2Content2: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer2Content2',
        defaultMessage: 'call us free on {phoneNumber} '
    },
    ExistingCustomerAnswer2Content3: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer2Content3',
        defaultMessage: 'and quote reference AM376D.'
    },
    ExistingCustomerAnswer3: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer3',
        defaultMessage: 'No, I am not currently insured with Saga'
    },
    ExistingCustomerAnswer3Content0: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer3Content0',
        defaultMessage: 'Don\'t worry - there are sometimes circumstances in which we can\'t provide a quote online, but can over the phone.'
    },
    ExistingCustomerAnswer3Content1: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer3Content1',
        defaultMessage: 'Please '
    },
    ExistingCustomerAnswer3Content2: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer3Content2',
        defaultMessage: 'call us free on {phoneNumber}'
    },
    ExistingCustomerAnswer3Content3: {
        id: 'qnb.spm.errorPage.ExistingCustomerAnswer3Content3',
        defaultMessage: ' - we\'ll be happy to help.'
    },
    Here: {
        id: 'qnb.spm.errorPage.Here',
        defaultMessage: 'here'
    },
    SagaHomepage: {
        id: 'qnb.spm.errorPage.SagaHomepage',
        defaultMessage: 'Saga homepage'
    },
    CallUsOn: {
        id: 'qnb.spm.errorPage.CallUsOn',
        defaultMessage: 'Call us on {number}'
    },
    DeclineErrorMessageAbilityToPay: {
        id: 'qnb.spm.errorPage.DeclineErrorMessageAbilityToPay',
        defaultMessage: 'Please call us on {phoneNumber}, 8:30am to 8pm weekdays and 9am to 5pm Saturday and Sunday, so we can discuss your options with you. The details of your quotation have been saved.'
    },
    ReturnToSagaHomepage: {
        id: 'qnb.spm.errorPage.ReturnToSagaHomepage',
        defaultMessage: 'Return to homepage'
    }
});
